import api from "lib/api";
// import apiFormData from "lib/apiFormData";

export const getCommonTypeCompany = async (params) => {
  return await api.post("/v1/mst/getCommonTypeCompanyPaging", params);
};

export const manageStatusCommonTypeCompany = async (params = {}) => {
  return await api.post("/v1/mst/manageStatusCommonTypeCompany", params);
};

export const createCommonTypeCompany = async (params) => {
  return await api.post("/v1/mst/createCommonTypeCompany", params);
};

export const updateCommonTypeCompany = async (params) => {
  return await api.post("/v1/mst/updateCommonTypeCompany", params);
};
